const adobe_api_key_prod = "17ebb4a8b3664975af50df256292fd66";
const adobe_api_key_test = "24b26014937d4dba92e71f78a5e6cdf9";
const adobe_api_key_dev = "8c0cd670273d451cbc9b351b11d22318";
const stripe = {
    testApiKey:'pk_test_51HtANmLDKSYnomwukTACBFleLGENCOeZrauMZzVPhJbARGsCsxD0xGPUAI13VCligAOQLwCCIBDCfQ4gAKn2aH4900C9Y2b1kv',
    testApiSecret: 'sk_test_51HtANmLDKSYnomwuijqfyGF5WUO5lF4ceKRxggOwXbFJ95uc9FEK1p4a1uXpIamZi5l1RwtQptc0lMbDOPXdcYxD00UsxvTwlZ',
    prodApiKey: 'pk_live_51HtANmLDKSYnomwujTqbPYGEESTZtKellYOfg17bgaMLu8KAGTcF2GVJCNGnohVPgsx0uUcnTeUEoxiRwTHL4nL800wuaTtL8p',
    prodApiSecret: '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'
}
module.exports={
    adobe_api_key_prod,
    adobe_api_key_test,
    adobe_api_key_dev,
    stripe
}